import {axiosPrivate} from "../axios";
import AuthenticationState from "../state/AuthenticationState";
import ProfileState from "../state/ProfileState";
import AuthenticationService from "../services/AuthenticationService";

const useAxiosPrivate = (useRequestInterceptors = true, useResponseInterceptors = true) => {
    const sessionActiveMinutes = 30;

    const requestInterceptor =
        axiosPrivate.interceptors.request.use(
            config => {
                if(useRequestInterceptors === true) {
                    if (!ProfileState.rememberMe.value) {
                        const maxDateTime = ProfileState.lastApiCall.value
                            ? new Date(ProfileState.lastApiCall.value.getTime() + sessionActiveMinutes * 60000)
                            : null;
                        const now = new Date();
                        if (!maxDateTime || now > maxDateTime) {
                            ProfileState.clear();
                            return Promise.reject('Session expired');
                        }
                    }
                    if (!config.headers['Authorization']) {
                        config.headers['Authorization'] = `Bearer ${AuthenticationState.accessToken?.value}`;
                    }
                }

                return config;
            }, (error) => Promise.reject(error)
        );

    const responseInterceptor =
        axiosPrivate.interceptors.response.use(
            response => {
                if(useResponseInterceptors === true) {
                    ProfileState.registerApiCallDate();
                }
                return response;
            },
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    await AuthenticationService.refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${AuthenticationState.accessToken.value}`;
                    return axiosPrivate(prevRequest);
                }
                return Promise.reject(error);
            }
        );

    // Detaching programatically if needed
    //axiosPrivate.interceptors.request.eject(requestInterceptor);
    //axiosPrivate.interceptors.response.eject(responseInterceptor);


    return axiosPrivate;
}

export default useAxiosPrivate;
